import { useEffect, useRef, useState, type FormEvent } from 'react';
import { contatoData } from '@/mocks/homeData';

export default function Contato() {
  const ref = useRef<HTMLElement>(null);
  const [inView, setInView] = useState(false);
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle');

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setInView(true);
      },
      { threshold: 0.2 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('sending');
    const form = e.currentTarget;
    const formData = new FormData(form);
    try {
      const res = await fetch('https://readdy.ai/api/form/d7rugqij1g8i0g4g5arg', {
        method: 'POST',
        body: new URLSearchParams(formData as unknown as Record<string, string>),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
      if (res.ok) {
        setStatus('sent');
        form.reset();
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section
      id="contato"
      ref={ref}
      className="bg-white py-28 md:py-36 lg:py-44 border-t border-black/[0.04]"
    >
      <div
        className={`max-w-[1200px] mx-auto px-6 md:px-12 lg:px-20 transition-all duration-1000 ease-editorial ${
          inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-start">
          {/* Left: title + description */}
          <div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-[3.5rem] font-extralight text-marrom tracking-tight leading-tight mb-8">
              {contatoData.title}
            </h2>
            <p className="font-body text-base md:text-lg font-light text-brand-gray-mid leading-[1.7] max-w-[420px]">
              {contatoData.description}
            </p>
          </div>

          {/* Right: form */}
      <form
  action="https://formsubmit.co/arquitetastephanielouise@gmail.com"
  method="POST"
  className="space-y-6"
>
  <input type="hidden" name="_captcha" value="false" />
  <input type="hidden" name="_next" value="https://stephaniezarowny.com.br" />

          
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="flex flex-col gap-2">
                <label
                  htmlFor="nome"
                  className="font-body text-sm font-normal text-marrom"
                >
                  Nome
                </label>
                <input
                  id="nome"
                  name="nome"
                  type="text"
                  required
                  placeholder="Nome (obrigatório)"
                  className="w-full px-5 py-3 rounded-full border border-marrom/30 bg-white font-body text-sm font-light text-brand-black placeholder:text-brand-gray-light focus:outline-none focus:border-marrom focus:ring-1 focus:ring-marrom/20 transition-colors"
                />
              </div>
              <div className="flex flex-col gap-2">
                <label
                  htmlFor="sobrenome"
                  className="font-body text-sm font-normal text-marrom"
                >
                  Sobrenome
                </label>
                <input
                  id="sobrenome"
                  name="sobrenome"
                  type="text"
                  required
                  placeholder="Sobrenome (obrigatório)"
                  className="w-full px-5 py-3 rounded-full border border-marrom/30 bg-white font-body text-sm font-light text-brand-black placeholder:text-brand-gray-light focus:outline-none focus:border-marrom focus:ring-1 focus:ring-marrom/20 transition-colors"
                />
              </div>
            </div>

            <div className="flex flex-col gap-2">
              <label
                htmlFor="email"
                className="font-body text-sm font-normal text-marrom"
              >
                E-mail
              </label>
              <input
                id="email"
                name="email"
                type="email"
                required
                placeholder="E-mail (obrigatório)"
                className="w-full px-5 py-3 rounded-full border border-marrom/30 bg-white font-body text-sm font-light text-brand-black placeholder:text-brand-gray-light focus:outline-none focus:border-marrom focus:ring-1 focus:ring-marrom/20 transition-colors"
              />
            </div>

            <div className="flex flex-col gap-2">
              <label
                htmlFor="tipo_projeto"
                className="font-body text-sm font-normal text-marrom"
              >
                O que vamos projetar hoje?
              </label>
              <select
                id="tipo_projeto"
                name="tipo_projeto"
                required
                className="w-full px-5 py-3 rounded-full border border-marrom/30 bg-white font-body text-sm font-light text-brand-black focus:outline-none focus:border-marrom focus:ring-1 focus:ring-marrom/20 transition-colors appearance-none cursor-pointer"
                style={{ backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%237c6f64' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")", backgroundRepeat: 'no-repeat', backgroundPosition: 'right 16px center' }}
              >
                <option value="" disabled selected>
                  Selecione uma opção
                </option>
                <option value="residencial">Meu novo lar (Residencial)</option>
                <option value="comercial">Meu espaço de trabalho (Comercial)</option>
                <option value="reforma">Reforma ou Ampliação</option>
                <option value="legal">Projetos Legais e Aprovações</option>
              </select>
            </div>

            <div className="flex flex-col gap-2">
              <label
                htmlFor="mensagem"
                className="font-body text-sm font-normal text-marrom"
              >
                Mensagem
              </label>
              <textarea
                id="mensagem"
                name="mensagem"
                rows={4}
                maxLength={500}
                placeholder="Conte-me um pouco sobre o seu sonho ou a necessidade do seu negócio..."
                className="w-full px-5 py-3 rounded-2xl border border-marrom/30 bg-white font-body text-sm font-light text-brand-black placeholder:text-brand-gray-light focus:outline-none focus:border-marrom focus:ring-1 focus:ring-marrom/20 transition-colors resize-none"
              />
              <p className="font-body text-xs font-light text-brand-gray-light text-right">
                Máximo 500 caracteres
              </p>
            </div>

            <div className="pt-2">
              <button
                type="submit"
                disabled={status === 'sending'}
                className="inline-flex items-center justify-center px-8 py-3.5 text-sm font-light text-white bg-marrom rounded-full hover:bg-[#4a3f38] transition-colors duration-300 whitespace-nowrap disabled:opacity-60 cursor-pointer"
              >
                {status === 'sending' ? 'Enviando...' : 'Vamos conversar sobre o meu projeto!'}
              </button>
            </div>

            {status === 'sent' && (
              <p className="font-body text-sm font-light text-green-700 mt-2">
                Mensagem enviada com sucesso! Entraremos em contato em breve.
              </p>
            )}
            {status === 'error' && (
              <p className="font-body text-sm font-light text-red-600 mt-2">
                Algo deu errado. Tente novamente mais tarde.
              </p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}